import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const state = { //要设置的全局访问的state对象
	gcfg: JSON.parse(localStorage.getItem("gcfg")) || null,
	distributor: JSON.parse(localStorage.getItem("distributor")) || null,
	shop: JSON.parse(localStorage.getItem("shop")) || null,
	supSetObj: null,
	supID: null,
	gGIndexPage: false,
	gGSupPage: false
};
const getters = { //实时监听state值的变化(最新状态)
	getgGSupPage() {
		return state.gGSupPage
	},
	getgGIndexPage() {
		return state.gGIndexPage
	},
	getGcfg() {
		return state.gcfg
	},
	getShop() {
		return state.shop
	},
	getDistributor() {
		return state.distributor
	},
	getsupSetObj() {
		return state.supSetObj
	},
	getsupID() {
		return state.supID
	}
};
const mutations = {
	setgGIndexPage(state, gGIndexPage) {
		state.gGIndexPage = gGIndexPage
	},
	setgGPage(state, gGSupPage) {
		state.gGSupPage = gGSupPage
	},
	setsupID(state, supID) {
		state.supID = supID
	},
	setsupSetObj(state, supSetObj) {
		state.supSetObj = supSetObj
	},
	setCFG(state, cfg) {
		state.gcfg = cfg
	},
	setShop(state, shop) {
		state.shop = shop
		localStorage.setItem("shop", JSON.stringify(shop))
	},
	setDistributor(state, distributor) {
		state.distributor = distributor
		localStorage.setItem("distributor", JSON.stringify(distributor))
	},
	logOut(state) {
		localStorage.clear();
		state.gcfg = null;
		state.distributor = null;
		state.shop = null;
		state.supSetObj = null;
		state.supID = null;
	}
};
const store = new Vuex.Store({
	state,
	getters,
	mutations
});
export default store;
